import { GoogleAnalyticsService } from "@rightship-tech/common-ui/services/analytics/google-analytics.service";
import { autoinject } from "aurelia-dependency-injection";
import { Router } from "aurelia-router";
import { DocumentManagementRoutes } from "../../../constants/route.constant";
import { GetDocumentRequirementResponse } from "../../../models/document-management.models";
import { DocumentRequirementApi } from "../../../apis/document-requirement.api";

@autoinject
export class SettingsDocumentRequirements {

    public documentRequirements: GetDocumentRequirementResponse[];
    public isLoading: boolean = true;
    public isRsUser: boolean = false;

    constructor(private router: Router, private documentRequirementApi: DocumentRequirementApi, private googleAnalyticsService: GoogleAnalyticsService) { }

    activate(params: { isRsUser: boolean }) {
        this.isRsUser = params?.isRsUser ?? false;
    }

    async attached() {

        //Get all document requirements
        this.documentRequirements = await this.documentRequirementApi.getMyDocumentRequirements();
        this.isLoading = false;
    }

    //Add a new document requirement
    public addRequirement() {

        //Send event to google analytics
        this.googleAnalyticsService.sendCustomGA4EventMulti("dmc_add_requirement_add_requirement_button", {});

        //Navigate to add document requirement page
        this.router.navigateToRoute(DocumentManagementRoutes.AddDocumentRequirements, { documentRequirementId: 0 });
    }
}